/**
 * Created by lihanying on 2017/7/14.
 */
import React from 'react'
import { Table, Input, Button, Upload, message, Select, Modal } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import XLSX from 'xlsx'
import './style.css'
import EditableCell from './editableCell'
import { changeToDecimal } from '../../../util'

const Option = Select.Option

class EditableTable extends React.Component {
  constructor(props) {
    super(props)
    this.columns = [
      {
        title: '姓名',
        dataIndex: 'name',
        width: '15%',
        render: (text, record, index) =>
          this.renderColumns(this.state.data, index, 'name', text),
      },
      {
        title: '电话',
        dataIndex: 'phone',
        width: '25%',
        render: (text, record, index) =>
          this.renderColumns(this.state.data, index, 'phone', text),
      },
      {
        title: '折扣',
        dataIndex: 'discount',
        width: '20%',
        render: (text, record, index) =>
          this.renderColumns(this.state.data, index, 'discount', text),
      },
      {
        title: '余额',
        dataIndex: 'amount',
        width: '20%',
        render: (text, record, index) =>
          this.renderColumns(this.state.data, index, 'amount', text),
      },
      {
        title: '操作',
        dataIndex: 'operation',
        render: (text, record, index) => {
          const { editable } = this.state.data[index].name
          return (
            <div className="editable-row-operations">
              {editable ? (
                <span>
                  <a onClick={() => this.editDone(index, 'save')}>保存</a>
                  <Popconfirm
                    title="您确认取消吗?"
                    onConfirm={() => this.editDone(index, 'cancel')}
                  >
                    <a>取消</a>
                  </Popconfirm>
                  <Popconfirm
                    title="您确认删除吗?"
                    onConfirm={() => this.onDelete(index)}
                  >
                    <a>删除</a>
                  </Popconfirm>
                </span>
              ) : (
                <span>
                  <a onClick={() => this.edit(index)}>编辑</a>
                </span>
              )}
            </div>
          )
        },
      },
    ]
    this.state = {
      data: [
        {
          key: '0',
          name: {
            editable: false,
            value: '',
          },
          phone: {
            editable: false,
            value: '',
          },
          discount: {
            editable: false,
            value: '',
          },
          amount: {
            editable: false,
            value: '',
          },
        },
      ],
      count: 2,
      dataSourceError: [],
      visible: false,
    }
  }
  renderColumns(data, index, key, text) {
    const { editable, status } = data[index][key]
    if (typeof editable === 'undefined') {
      return text
    }
    return (
      <EditableCell
        editable={editable}
        value={text}
        onChange={(value) => this.handleChange(key, index, value)}
        status={status}
      />
    )
  }
  handleChange(key, index, value) {
    const { data } = this.state
    data[index][key].value = value
    this.setState({ data })
  }

  edit(index) {
    const { data } = this.state
    Object.keys(data[index]).forEach((item) => {
      if (
        data[index][item] &&
        typeof data[index][item].editable !== 'undefined'
      ) {
        data[index][item].editable = true
      }
    })
    this.setState({ data })
  }
  editDone(index, type) {
    const { data } = this.state
    Object.keys(data[index]).forEach((item) => {
      if (
        data[index][item] &&
        typeof data[index][item].editable !== 'undefined'
      ) {
        data[index][item].editable = false
        data[index][item].status = type
      }
    })
    this.setState({ data }, () => {
      Object.keys(data[index]).forEach((item) => {
        if (
          data[index][item] &&
          typeof data[index][item].editable !== 'undefined'
        ) {
          delete data[index][item].status
        }
      })
    })
  }

  onDelete = (index) => {
    const data = [...this.state.data]
    data.splice(index, 1)
    this.setState({ data })
  }

  handleAdd = () => {
    const { count, data } = this.state
    const newData = {
      key: count,
      name: {
        editable: false,
        value: '',
      },
      phone: {
        editable: false,
        value: '',
      },
      discount: {
        editable: false,
        value: '',
      },
      amount: {
        editable: false,
        value: '',
      },
    }
    this.setState(
      {
        data: [...data, newData],
        count: count + 1,
      },
      () => {
        this.edit(this.state.data.length - 1)
      }
    ) //点击添加时编辑
  }

  //导出报表
  clickDownload = (columns) => {
    let str = [],
      title = []
    columns.map((item) => {
      title.push(item.title)
    })
    str.push(title.join(','))
    str = encodeURIComponent(str.join('\n'))
    return 'data:text/csv;charset=utf-8,\ufeff' + str
  }

  //上传csv表
  onUpload = (e) => {
    let files = e.target.files
    let that = this
    if (files && typeof files !== 'undefined') {
      let reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        var workbook = XLSX.read(data, { type: 'binary' })
        var persons = []
        // 表格的表格范围，可用于判断表头是否数量是否正确
        // var fromTo = '';
        for (var sheet in workbook.Sheets) {
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            // fromTo = workbook.Sheets[sheet]['!ref'];
            persons = persons.concat(
              XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
            )
          }
        }

        const finDatas = []
        for (let i = 0; i < persons.length; i++) {
          const objs = persons[i]
          var newData = { key: i + 1 }
          const values = Object.values(objs)
          for (let i = 0; i < values.length; i++) {
            const val = values[i]
            if (i == 0) {
              let name = val.toString().trim()
              name.replace('\r', '')
              name.replace('\n', '')
              newData['name'] = { editable: false, value: name }
            } else if (i == 1) {
              newData['phone'] = { editable: false, value: val + '' }
            } else if (i == 2) {
              newData['discount'] = {
                editable: false,
                value: val > 10 ? 10 : val,
              }
            } else if (i == 3) {
              newData['amount'] = { editable: false, value: val }
            }
          }
          finDatas.push(newData)
        }
        that.setState({ data: finDatas })
        console.log('结果集：', finDatas)
      }
      if (files[0]) {
        // reader.readAsBinaryString(files[0]);
        reader.readAsText(files[0], 'gb2312')
      }
    } else {
      alert('This browser does not support HTML5.')
    }
  }

  //提交
  handleSubmit = (value) => {
    let newArr = []
    let dataSourceError = []
    if (this.state.option) {
      for (let i = 0; i < value.length; i++) {
        if (
          value[i].phone.length != 11 ||
          +value[i].discount > 10 ||
          +value[i].discount < 0
        ) {
          dataSourceError = [].concat(dataSourceError, {
            //格式不符合的数据
            id: i,
            name: value[i].name,
            phone: value[i].phone,
            discount: value[i].discount,
            amount: value[i].amount,
          })
        } else {
          newArr = [].concat(newArr, {
            member_name: value[i].name,
            account: value[i].phone,
            disNum: +changeToDecimal(value[i].discount / 10),
            money: value[i].amount * 100,
            wallet_id: this.state.option || 0,
          })
        }
      }
      this.setState({ dataSourceError: dataSourceError, data: [] })
      if (dataSourceError.length > 0) {
        //如果有格式错误的数,弹模态框,提示在提交
        this.setState({
          dataSourceError: dataSourceError,
          newArr: newArr,
          visible: true,
        })
      } else {
        this.props.fetchAddClubMember({ newArray: newArr })
        this.setState({
          data: [
            {
              key: '0',
              name: {
                editable: false,
                value: '',
              },
              phone: {
                editable: false,
                value: '',
              },
              discount: {
                editable: false,
                value: '',
              },
              amount: {
                editable: false,
                value: '',
              },
            },
          ],
          count: 2,
        }) //清空
      }
    } else {
      message.info('选择余额充值的钱包')
    }
  }

  //模态框
  handleOk = (e) => {
    this.setState(
      {
        visible: false,
      },
      () => this.props.fetchAddClubMember({ newArray: this.state.newArr })
    )
  }
  handleCancel = (e) => {
    this.setState({
      visible: false,
    })
  }

  render() {
    const { data, dataSourceError } = this.state
    const { walletInfo } = this.props
    const dataSource = data.map((item) => {
      const obj = {}
      Object.keys(item).forEach((key) => {
        obj[key] = key === 'key' ? item[key] : item[key].value
      })
      return obj
    })
    const columns = this.columns
    const columnsError = [
      {
        title: '姓名',
        dataIndex: 'name',
      },
      {
        title: '电话',
        dataIndex: 'phone',
      },
      {
        title: '折扣',
        dataIndex: 'discount',
      },
      {
        title: '余额',
        dataIndex: 'amount',
      },
    ]
    return (
      <div style={{ position: 'relative' }}>
        <div className="editable-top-info">
          <div>
            <p>批量导入会员操作步骤:</p>
            <p>1.先导出登记会员表格模板</p>
            <p>2.在模板上填写正确格式会员</p>
            <p>3.上传填写好的会员表</p>
          </div>
          <div className="editable-top-reminder">
            <Button className="editable-add-btn">
              <a
                id="test"
                href={this.clickDownload(columnsError)}
                download="download.xls"
              >
                导出模板
              </a>
            </Button>
            <Button className="editable-add-btn">
              <input
                type="file"
                accept=".xls"
                className="editable-add-input"
                onChange={(e) => this.onUpload(e)}
              />
              上传会员表
            </Button>
          </div>
        </div>
        {walletInfo.length > 0 && (
          <Select
            placeholder="选择余额充值的钱包"
            style={{ width: 200, marginRight: '1rem' }}
            onChange={(value) => this.setState({ option: value })}
          >
            {walletInfo.map((item, idx) => {
              return (
                <Option value={item.id} key={idx}>
                  {item.name}
                </Option>
              )
            })}
          </Select>
        )}
        <Button
          type="primary"
          className="editable-submit-btn"
          onClick={() => this.handleSubmit(dataSource)}
        >
          提交
        </Button>
        <Table
          bordered
          dataSource={dataSource}
          columns={columns}
          style={{ marginTop: '1rem' }}
        />
        <div className="editable-bottom">
          <Button className="editable-add-btn" onClick={this.handleAdd}>
            添加会员
          </Button>
          <i>
            温馨提示: 输入的手机号码必须是
            <span style={{ color: '#108EE9' }}>11位</span>
            ，如无折扣请输入10，如设置七五折,
            <span style={{ color: '#108EE9' }}>请输入7.5</span>，余额请选择
            <span style={{ color: '#108EE9' }}>充值的钱包</span>。
          </i>
        </div>
        {dataSourceError.length > 0 && (
          <span>
            <p style={{ color: 'black' }}>筛选格式不对的会员表</p>
            <Table
              rowKey="id"
              bordered
              dataSource={dataSourceError}
              columns={columnsError}
            />
          </span>
        )}

        <Modal
          title="筛选格式不正确的会员"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <p>
            一共筛选了{dataSourceError.length}条格式不正确的会员,您是否继续上传
          </p>
        </Modal>
      </div>
    )
  }
}

export default EditableTable



// WEBPACK FOOTER //
// ./src/containers/ClubMember/component/editableTable.js